/**
 * Checks whether objectFit is supported by browser, or not.
 * If no support was detected, the images is transformed using javascript to achieve a similar result
 */
export function PolyfillImages(){
	if (!('objectFit' in document.documentElement.style)) {
		$('img[data-object-fit]:not([data-object-fit=""])').each(function(index, image) {
			(image.runtimeStyle || image.style).background = `url("${image.src}") no-repeat 50%/${image.currentStyle ? image.currentStyle['object-fit'] : image.getAttribute('data-object-fit')}`;
			image.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${image.width}' height='${image.height}'%3E%3C/svg%3E`
		});
	}
}